import { Button } from "react-bootstrap"

export function AfterSendDemo() {
  if (!isWeekend) {
    return <RU />
  } else {
    return <RUWeekend />
  }
}

// Проверяем день недели и определяем выходные
const yourDateObject = new Date()
const date = yourDateObject.getDate()
const day = yourDateObject.getDay()
const isWeekend = day === 6 || day === 0 // 6 = Saturday, 0 = Sunday

const RU = () => (
  <div className="afterSend row align-items-center">
    <p>
      <b>Спасибо за заявку!</b>
    </p>
    <p className="mt-4">
      Мы позвоним вам с номера{" "}
      <a href="tel:+74954766055" style={{ whiteSpace: "nowrap", hyphens: "none", fontWeight: "bold" }}>
        +7 (495) 476-60-55
      </a>
      <br />с 9:00 до 18:00 МСК пн-пт
      {/*Поздравляем с наступающим 2026 годом! 🎄*/}
      {/*<br />*/}
      {/*Поддержка будет работать в праздничные дни.*/}
      {/*<br />*/}
      {/*<br />*/}
      {/*Заявки на демо начнем обрабатывать с 12 января.*/}
    </p>
  </div>
)

const RUWeekend = () => (
  <div className="afterSend afterSendWeekend row align-items-center">
    <div>
      <p>Мы получили заявку! Наши менеджеры перезвонят вам в понедельник с 10:00 до 12:00</p>
      <p>
        Чтобы вы не грустили в ожидании звонка, мы дарим вам готовые сценарии использования поп‑апов и чат‑бота, которые помогут вашему бизнесу зарабатывать
        больше
      </p>
      <Button href="tg://resolve?domain=days_off_cqbot&start=c1676975943615-ds" target="_blank" className="mb-3 w-100">
        Получить сценарии в Telegram
      </Button>
      <Button onClick={() => carrotquest.track("Запросил сценарии в чат на сайте из формы выходных дней", {})} className="w-100">
        Получить сценарии в чат на сайте
      </Button>
    </div>
  </div>
)
